import React, { useEffect, useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';
import DataContext from '../../../data/data-context';
import DisplayCard from '../../../components/displaycard';

const anomalyRules = [
    {
        title: 'OpenSearch Rules',
        subtitle: 'Anomaly Detection',
        description: 'Manage OpenSearch anomaly detection rules',
        img: '/images/analytics.png',
        route: '/system/anomaly_detection/opensearch',
        perm: {
            OpenSearchAnomalies: [...Permissions.System.AnomalyDetection.OpenSearchAnomalies],
        },
    }
];

const AnomalyRules = (props) => {
    const { systemSettings } = useContext(DataContext);
    const [updatedAnomalies, setUpdatedAnomalies] = useState(anomalyRules);

    useEffect(() => {
        const updatedAnamolies = anomalyRules.map(item => {
            if (systemSettings?.opensearch) {
                if (item.title === 'OpenSearch') {
                    return {
                        ...item,
                        route: '/system/anomaly_detection/opensearch',
                    };
                }
            }
            return item;
        });

        setUpdatedAnomalies(updatedAnamolies);
    }, [systemSettings.opensearch]);

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {updatedAnomalies.filter(o => Auth.perm(o.perm)).map((p, i) => (
                        <Grid item xl={3} lg={4} key={`anamolies-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
};

export default AnomalyRules;
